"use client";

import cnBind from "classnames/bind";
import { useTranslation } from "react-i18next";

import { startHref, trackMarketing } from "@/components/marketing/launch";

import styles from "./NicheOffersBlock.module.scss";

const cx = cnBind.bind(styles);

type IndustryItem = {
    slug: string;
    label: string;
    oneLiner: string;
};

/**
 * Компактный выбор сферы: без огромных карточек со скриншотами CRM.
 */
export const NicheOffersBlock = () => {
    const { t } = useTranslation("common");
    const industries = t("home.nicheOffers.industries", { returnObjects: true }) as IndustryItem[];
    const nicheExamples = t("home.nicheOffers.nicheExamples", { returnObjects: true }) as Record<
        string,
        string[]
    >;
    const items = Array.isArray(industries) ? industries : [];

    return (
        <section className={cx("section")} id="industries" aria-labelledby="preset-offers-title">
            <div className={cx("inner", "container")}>
                <p className={cx("eyebrow")}>{t("home.nicheOffers.eyebrow")}</p>
                <h2 id="preset-offers-title" className={cx("title")}>
                    {t("home.nicheOffers.title")}
                </h2>
                <p className={cx("lead")}>{t("home.nicheOffers.lead")}</p>

                <div className={cx("list")}>
                    {items.map((item) => {
                        const href = `/solutions/${item.slug}`;
                        const examples = nicheExamples?.[item.slug] || [];

                        return (
                            <article key={item.slug} className={cx("row")}>
                                <div className={cx("rowMain")}>
                                    <h3>
                                        <a
                                            href={href}
                                            onClick={() =>
                                                trackMarketing("industry_select", {
                                                    industry: item.slug,
                                                    source: "home_presets",
                                                })
                                            }
                                        >
                                            {item.label}
                                        </a>
                                    </h3>
                                    <p>{item.oneLiner}</p>
                                    {examples.length ? (
                                        <div className={cx("chips")}>
                                            {examples.map((label) => (
                                                <a key={label} className={cx("chip")} href={href}>
                                                    {label}
                                                </a>
                                            ))}
                                        </div>
                                    ) : null}
                                </div>
                                <a className={cx("rowCta")} href={href}>
                                    {t("home.nicheOffers.rowCta")}
                                    <span aria-hidden>→</span>
                                </a>
                            </article>
                        );
                    })}
                </div>

                <a className={cx("startLink")} href={startHref()}>
                    {t("home.nicheOffers.startLink")}
                </a>
            </div>
        </section>
    );
};
